import React, { useEffect, useState } from 'react';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic/';
import {
  useGetCalendarEventsQuery,
  useDeleteCalendarEventMutation,
  useImportCalendarEventMutation,
} from '../../../../../redux/services/events.jsx';
import { CollapseBlock, Spinner } from '../../../../common/';
import EventsTable from './EventsTable.jsx';
import CalendarImport from './EventsImport/EventsImport.jsx';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { isString } from 'lodash';

const EventsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Kalendár') + ' - FRI CMS';
  }, []); // Runs on mount

  // Toast helpers
  const {
    successMessage,
    deleteSuccess: showDeleteSuccess,
    errorMessage,
  } = useToastMessages();

  // Queries & Mutations
  const { data: calendar, isLoading, refetch } = useGetCalendarEventsQuery();

  const [deleteCalendarEvent, { isSuccess: isDeleteSuccess }] =
    useDeleteCalendarEventMutation();

  const [importCalendarEvent, { data: importData, reset: resetImport }] =
    useImportCalendarEventMutation();

  // Local state
  const [importOpen, setImportOpen] = useState(false);

  // Delete calendar event effect
  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  // Handle import submit
  const handleImportSubmit = (values) => {
    importCalendarEvent({ body: values })
      .unwrap()
      .then((response) => {
        const errorMsg = response?.error;
        if (!errorMsg || (isString(errorMsg) && errorMsg.trim() === '')) {
          successMessage({
            message: t('Import úspešne vykonaný'),
          });
          setImportOpen(false);
          refetch();
        } else {
          errorMessage({
            message: t('Import neúspešný. Chyba v súbore.'),
          });
        }
      })
      .catch((error) => {
        const fallbackMsg =
          error?.data?.error ||
          error?.message ||
          t('Nastala chyba pri importe');
        errorMessage({
          message: fallbackMsg,
        });
      });
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      {importOpen && (
        <CalendarImport
          toggle={() => {
            setImportOpen(false);
            resetImport();
          }}
          validationErrors={importData?.error || {}}
          onSubmit={handleImportSubmit}
        />
      )}

      <AppBarCMS
        title={t('Kalendár')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať udalosť')}
        createUrl={routes.cmsCalendarCreate}
        permissionsBasic={'calendar'}
        mainActions={[
          {
            icon: <UploadOutlined />,
            title: t('Importovať udalosti'),
            onClick: () => setImportOpen(true),
            permission: 'calendar-import',
          },
        ]}
      />

      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <EventsTable
            calendar={calendar}
            onEditClick={(record) =>
              navigate(`${routes.cmsCalendarEdit}/${record.id}`)
            }
            onDelete={(calendarItem) => deleteCalendarEvent(calendarItem.id)}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default EventsPage;
